import styled from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';

export const FiltersDesktop = styled.div`
  display: flex;
  width: fit-content;
  gap: 0.5rem;

  ${media.mediumDown`
    display: none;
  `}
`;

export const AppliedFiltersWrapper = styled.div`
  margin: ${layout.measurements.spacing050};
`;
